import { Controller } from '@hotwired/stimulus'
import { loadApexCharts } from '../utils/chart_loader'

export default class extends Controller {
  static values = {
    series: Array,  // Array of series objects for stacked bar
    categories: Array  // X-axis labels (score ranges: 0-6, 7-8, 9-10)
  }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  async initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const ApexCharts = (await loadApexCharts()).default

    const options = {
      chart: {
        type: 'bar',
        height: 350,
        stacked: false,
        toolbar: {
          show: true,
          tools: {
            download: true
          }
        },
        fontFamily: 'Inter, system-ui, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800
        }
      },
      colors: ['#EF4444', '#FBBF24', '#10B981'],  // Red for detractors, Yellow for passives, Green for promoters
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 8,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          fontWeight: '600',
          colors: ['#374151']
        },
        background: {
          enabled: false
        }
      },
      series: this.seriesValue,
      xaxis: {
        categories: this.categoriesValue,
        title: {
          text: 'Pontuação NPS',
          style: {
            fontSize: '12px',
            fontWeight: 600,
            color: '#6b7280'
          }
        },
        labels: {
          style: {
            colors: '#9ca3af',
            fontSize: '12px',
            fontWeight: 500
          }
        }
      },
      yaxis: {
        title: {
          text: 'Número de Respostas',
          style: {
            fontSize: '12px',
            fontWeight: 600,
            color: '#6b7280'
          }
        },
        labels: {
          style: {
            colors: '#9ca3af',
            fontSize: '11px'
          },
          formatter: (value) => Math.round(value)
        }
      },
      grid: {
        borderColor: '#f3f4f6',
        strokeDashArray: 4,
        xaxis: {
          lines: { show: false }
        },
        yaxis: {
          lines: { show: true }
        }
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        theme: 'light',
        style: { fontSize: '12px' },
        y: {
          formatter: (value) => `${value} resposta${value !== 1 ? 's' : ''}`
        }
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'right',
        fontSize: '12px',
        fontWeight: 500,
        labels: {
          colors: '#374151'
        },
        markers: {
          width: 10,
          height: 10,
          radius: 4
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.2,
          opacityFrom: 1,
          opacityTo: 0.85,
          stops: [0, 100]
        }
      },
      states: {
        hover: {
          filter: {
            type: 'darken',
            value: 0.9
          }
        }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
